import { useAppQuery } from "~/hooks/useAppQuery"
import { getGroups } from "../server/catalog.functions"
import { catalogGroupsQueryKey } from "../query-keys"

export function useGroups() {
  return useAppQuery({
    queryKey: catalogGroupsQueryKey(),
    queryFn: () => getGroups(),
    errorMessage: "Не удалось загрузить группы",
  })
}
